import { render, staticRenderFns } from "./MessageMobileContainer.vue?vue&type=template&id=39d1aadb&scoped=true&"
import script from "./MessageMobileContainer.vue?vue&type=script&lang=js&"
export * from "./MessageMobileContainer.vue?vue&type=script&lang=js&"
import style0 from "./MessageMobileContainer.vue?vue&type=style&index=0&id=39d1aadb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d1aadb",
  null
  
)

export default component.exports